import posthog from 'posthog-js';

export function trackSignupCompleted(identifier, useEmail = true) {
    const key = useEmail ? 'email' : 'phoneNumber';
    posthog.capture('signup_completed', {
        [key]: identifier,
    });
}

export function trackSignupStarted(identifier, useEmail = true) {
    const key = useEmail ? 'email' : 'phoneNumber';
    posthog.capture('signup_started', {
        [key]: identifier,
    });
}


export function trackLogin(identifier, useEmail = true) {
    const key = useEmail ? 'email' : 'phoneNumber';
    posthog.capture('login', {
        [key]: identifier,
    });
}



export function trackLoggedIn(identifier, useEmail = true) {
    const key = useEmail ? 'email' : 'phoneNumber';
    posthog.identify('login', {
        [key]: identifier,
    });
}